/* kaufweise Laenderhinweis: reine Zuordnungslogik (Land + aktueller Host + Browsersprache
   -> Ziel-Markt), OHNE jede DOM-/Netzwerk-Abhaengigkeit. Laeuft unveraendert im Browser
   (als <script>-Tag vor kw-market-hint.js) UND in Node (per require/vm, kein import/export,
   kein Modul-System), damit dieselbe Datei per node einem Selbsttest unterzogen werden kann.
   Datengrundlage: PLAN-markets-weiche.md Abschnitt "Maerkte und Ziel-URLs" (05.09.2026). */
(function (root) {
  "use strict";

  // Jeder eigene Host -> Markt-Schluessel + eigenes Land (fuer die Anzeige "unser Shop fuer X").
  var MARKETS = {
    de:  { host: "kaufweise.de",       ownCountry: "DE" },
    nl:  { host: "kaufweise.nl",       ownCountry: "NL" },
    com: { host: "kaufweise.com",      ownCountry: "GB" },
    fr:  { host: "fr.kaufweise.com",   ownCountry: "FR" },
    it:  { host: "it.kaufweise.com",   ownCountry: "IT" },
    es:  { host: "es.kaufweise.com",   ownCountry: "ES" },
    pl:  { host: "pl.kaufweise.com",   ownCountry: "PL" },
    bg:  { host: "bg.kaufweise.com",   ownCountry: "BG" },
    cz:  { host: "cz.kaufweise.com",   ownCountry: "CZ" },
    dk:  { host: "dk.kaufweise.com",   ownCountry: "DK" },
    ee:  { host: "ee.kaufweise.com",   ownCountry: "EE" },
    fi:  { host: "fi.kaufweise.com",   ownCountry: "FI" },
    gr:  { host: "gr.kaufweise.com",   ownCountry: "GR" },
    hr:  { host: "hr.kaufweise.com",   ownCountry: "HR" },
    hu:  { host: "hu.kaufweise.com",   ownCountry: "HU" },
    lt:  { host: "lt.kaufweise.com",   ownCountry: "LT" },
    lv:  { host: "lv.kaufweise.com",   ownCountry: "LV" },
    se:  { host: "se.kaufweise.com",   ownCountry: "SE" }
  };

  // Reihenfolge fuer den Tie-Break, wenn ein Land in mehreren Maerkten steht und die
  // Browsersprache keine eindeutige Wahl liefert (erster Treffer in dieser Liste gewinnt).
  var PRIORITY_ORDER = ["de", "nl", "com", "fr", "it", "es", "pl", "bg", "cz", "dk", "ee",
    "fi", "gr", "hr", "hu", "lt", "lv", "se"];

  // Land -> Sprach-Praefix, mit dem ein Markt eindeutig disambiguiert wird (nur fuer Laender,
  // die in mehreren Regionen-Listen vorkommen, relevant).
  var MARKET_LANGUAGE = { de: "de", nl: "nl", com: "en", fr: "fr", it: "it", es: "es",
    pl: "pl", bg: "bg", cz: "cs", dk: "da", ee: "et", fi: "fi", gr: "el", hr: "hr", hu: "hu",
    lt: "lt", lv: "lv", se: "sv" };

  // Land -> eindeutiger Markt (keine Ueberschneidung mit anderen Maerkten).
  var UNIQUE_COUNTRY = {
    DE: "de", AT: "de", LI: "de",
    NL: "nl",
    GB: "com", IE: "com", CY: "com", MT: "com",
    FR: "fr", MC: "fr",
    IT: "it", SM: "it", VA: "it",
    ES: "es", PL: "pl", BG: "bg", CZ: "cz", DK: "dk", EE: "ee", FI: "fi", GR: "gr",
    HR: "hr", HU: "hu", LT: "lt", LV: "lv", SE: "se"
  };

  // Laender, die laut Plan in MEHREREN Markt-Regionen gleichzeitig stehen (mehrsprachige
  // Laender): Zielwahl per Accept-Language, sonst per PRIORITY_ORDER.
  var AMBIGUOUS_COUNTRY = {
    BE: ["de", "nl", "fr"],
    LU: ["de", "fr"]
  };

  // Schweiz: eigene, im Auftrag fest vorgegebene Behandlung ("behandle CH als
  // kaufweise.de/de-ch"), keine Sprachauswahl noetig, ein einziges Ziel.
  var CH_TARGET_MARKET = "de";
  var CH_TARGET_PATH_PREFIX = "/de-ch";

  function hostToMarket(host) {
    host = String(host || "").toLowerCase().replace(/^www\./, "");
    for (var key in MARKETS) {
      if (MARKETS[key].host === host) return key;
    }
    return null;
  }

  function pickByLanguage(candidates, acceptLanguagePrimary) {
    var lang = String(acceptLanguagePrimary || "").toLowerCase().slice(0, 2);
    if (lang) {
      for (var i = 0; i < candidates.length; i++) {
        if (MARKET_LANGUAGE[candidates[i]] === lang) return candidates[i];
      }
    }
    var byPriority = PRIORITY_ORDER.filter(function (k) { return candidates.indexOf(k) !== -1; });
    return byPriority[0] || candidates[0];
  }

  /**
   * @param {string} currentHost aktueller Hostname, z. B. "kaufweise.nl"
   * @param {string} detectedCountry ISO-3166-1-alpha-2, z. B. "DE" (aus
   *   /browsing_context_suggestions.json detected_values.country.handle)
   * @param {string} [acceptLanguagePrimary] primaeres Sprachkuerzel des Besuchers, z. B. "fr"
   * @returns {null|{marketKey:string, host:string, pathPrefix:string}} null = kein Hinweis
   */
  function resolveTarget(currentHost, detectedCountry, acceptLanguagePrimary) {
    var country = String(detectedCountry || "").toUpperCase();
    if (!country) return null;
    var currentMarket = hostToMarket(currentHost);

    if (country === "CH") {
      if (currentMarket === CH_TARGET_MARKET) return null;
      return { marketKey: CH_TARGET_MARKET, host: MARKETS[CH_TARGET_MARKET].host, pathPrefix: CH_TARGET_PATH_PREFIX };
    }

    var candidates = null;
    if (AMBIGUOUS_COUNTRY[country]) {
      candidates = AMBIGUOUS_COUNTRY[country];
    } else if (UNIQUE_COUNTRY[country]) {
      candidates = [UNIQUE_COUNTRY[country]];
    } else {
      return null; // Land in keinem Markt (z. B. US)
    }

    if (currentMarket && candidates.indexOf(currentMarket) !== -1) return null;

    var target = candidates.length > 1 ? pickByLanguage(candidates, acceptLanguagePrimary) : candidates[0];
    return { marketKey: target, host: MARKETS[target].host, pathPrefix: "" };
  }

  var api = { resolveTarget: resolveTarget, MARKETS: MARKETS, UNIQUE_COUNTRY: UNIQUE_COUNTRY,
    AMBIGUOUS_COUNTRY: AMBIGUOUS_COUNTRY };

  if (typeof module !== "undefined" && module.exports) {
    module.exports = api; // Node-Test (require) faellt hierauf zurueck, kein import noetig
  }
  root.KwMarketHint = root.KwMarketHint || {};
  root.KwMarketHint.resolveTarget = resolveTarget;
  root.KwMarketHint.MARKETS = MARKETS;
})(typeof window !== "undefined" ? window : (typeof globalThis !== "undefined" ? globalThis : this));
